import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { PatientModel } from './../../../models/consultation/patient.model';
import { PatientDetailService } from './patient-detail.service';
import { AppConstants } from '../../../shared/constants/constants';
import { ConsultationProcessService } from '../consultation-process.service';
import { ConsultationStep } from '../../../models/consultation/consultation.model';
import { DialogService } from './../../../shared/services/dialog.service';
import { BaseConsultationComponent } from '../base-consultation/base-consultation.component';

@Component({
    selector: 'patient-detail',
    templateUrl: 'patient-detail.component.html',
    providers: [PatientDetailService]
})

export class PatientDetailComponent extends BaseConsultationComponent implements OnInit, OnDestroy {
    public klass = 'patientDetail';
    public appConstants = AppConstants;
    public data = new PatientModel();

    constructor(public dialogService: DialogService,
                public consultationProcessService: ConsultationProcessService,
                public router: Router,
                public activeRouter: ActivatedRoute,
                public patientDetailService: PatientDetailService) {
        super(dialogService, consultationProcessService, router, activeRouter, ConsultationStep.PatientDetails);
        this.consultationProcessService.getPatientInfo().subscribe(result => {
            if (result) {
                this.data = Object.assign(this.data, result);
            }
        });
    }

    ngOnInit() {
        this.patientDetailService.getPatientDetail(this.filterParam.patientId).subscribe(
            (result) => {
                if (result) {
                    const patient = result.json();
                    this.data = patient;
                }
            }
        );
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
    }

    /**
     * over write from BaseConsultationComponent
     * this function will be called when user click on breakscrum step or next, prev button
     */
    changeConsultationStep() {
        this.consultationProcessService.moveToNextStep(this.filterParam.id, ConsultationStep.PatientDetails).subscribe(
            (result) => {
                if (result) {
                    this.navigateAction();
                }
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/patient-detail/patient-detail.component.ts